import React, { useContext } from 'react';
import DIServices from "./DIServices";

// Array for contexts created from the DIServices enum list
const contexts = new Map<DIServices, React.Context<any | undefined>>();

/**
 * The central hub for all DI services
 * This hub keeps track of all  contexts and - when a particular service is asked for - 
 * it checks if it exists and returns an appropriate error if it doesn't.
 */
const DIContainer = {

    /**
     * Creates the context and store it in the internal contexts Map
     * @param service The service for which the context will be created
     * @returns created context
     */
    createContext: <T>(svc: DIServices): React.Context<T | undefined> => {

        console.debug(`calling DI.createContext for ${DIServices[svc]}`);
        const context = React.createContext<T | undefined>(undefined);
        contexts.set(svc, context);
        return context;

    },

    /**
     * Gets the service context
     * @param svc 
     * @returns Service context
     */
    use: <T>(svc: DIServices): T => {

        //console.debug(`calling DI.use ${DIServices[svc]}`);
        // try to get the context from stored context array
        const context = contexts.get(svc);
        if (context === undefined) {
            throw new Error(`${DIServices[svc]} was not created`);
        }

        // get the serviceContext using the React.useContext
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const service = useContext(context);
        if (service === undefined) {
            throw new Error(`You must use ${DIServices[svc]} from within its service`);
        }

        // return the service
        return service;


    },

    clear() {
        contexts.clear();
    }
};

export default DIContainer;